module.exports = __webpack_public_path__ + "img/logo-atlanta.svg";